<div class="modal-body p-4 w-100">
  <div class="flex justify-content-center w-100" *ngIf="leg">
    <app-change-flights-departing-flight-information [leg]="leg" [delayCodes]="delayCodes"
                                                     [passengerClasses]="passengerClasses"></app-change-flights-departing-flight-information>
  </div>
</div>
